


















































































import { Component, Prop, Vue } from 'vue-property-decorator';

import {
  EDayOfTheWeek,
  IOpeningHoursData,
  IOpeningHoursPeriods
} from '@/api/OpeningHoursService';
import { upperCaseFirstLetter } from '@/utils/string';
import _ from 'lodash';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import Checkbox from '@/components/Checkbox/Checkbox.vue';
import TimePicker from '@/componentsV2/molecules/TimePicker/TimePicker.vue';
import PlusCircle from '@/components/icons/PlusCircle.vue';
import TrashIcon from '@/components/icons/Trash.vue';

@Component({
  components: {
    Typography,
    Checkbox,
    TimePicker,
    PlusCircle,
    TrashIcon
  }
})
export default class OpeningHourItem extends Vue {
  @Prop() dayOfTheWeek!: EDayOfTheWeek;
  @Prop() periodData!: Record<EDayOfTheWeek, IOpeningHoursData>;

  upperCaseFirstLetter = upperCaseFirstLetter;

  get periods() {
    const periods = this.periodData[this.dayOfTheWeek].periods;
    return periods.filter(
      period =>
        !period.businessLocationId ||
        period.businessLocationId === periods[0].businessLocationId
    );
  }

  changeOpen(value: boolean) {
    this.$emit('changeOpen', this.dayOfTheWeek, value);
  }

  changePeriod(period: IOpeningHoursPeriods, column: string, value: string) {
    this.$emit(
      'changePeriod',
      this.dayOfTheWeek,
      _.cloneDeep(period),
      column,
      value
    );
  }

  addNewPeriod() {
    if (this.periods.length > 3) {
      this.$notification(
        'You have reached the maximum number of periods allowed per day',
        'error'
      );
      return;
    }
    this.$emit('addNewPeriod', this.dayOfTheWeek, {
      temporaryId: Math.floor(Math.random() * 100000000),
      openTime: '--:--:--',
      closeTime: '--:--:--'
    });
  }

  deletePeriod(period: IOpeningHoursPeriods) {
    this.$emit('deletePeriod', this.dayOfTheWeek, period);
  }
}
